var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100vh","min-height":"100vh","z-index":"-1","background":"black"}})
}
var staticRenderFns = []

export { render, staticRenderFns }